import { render } from "./TripDetails.vue?vue&type=template&id=7af7a016&scoped=true&ts=true"
import script from "./TripDetails.vue?vue&type=script&lang=ts"
export * from "./TripDetails.vue?vue&type=script&lang=ts"

import "./TripDetails.vue?vue&type=style&index=0&id=7af7a016&scoped=true&lang=css"

import exportComponent from "D:\\curso VUE\\maps-app\\maps-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af7a016"]])

export default __exports__